module.exports = "/_next/static/images/kevelos_top-ac055845c6e00ad24d8ee56e96914ff2.jpg";